import {Component, OnInit} from '@angular/core';
import {EnvironmentService} from '../../core/services/environment.service';
import {ActivatedRoute} from '@angular/router';

@Component({
    selector: 'fss-portal-load-error',
    templateUrl: './load-error.component.html',
    styleUrls: ['./load-error.component.scss'],
    standalone: false
})
export class LoadErrorComponent implements OnInit {

  public goFollettLink: string = '';
  public missingAppIdError: boolean = false;

  constructor(
    private envService: EnvironmentService,
    private route: ActivatedRoute
  ){}

  public ngOnInit(): void {
    try {
      const errorType = this.route.snapshot.paramMap.get('type');
      if (errorType === 'missing-app-id') {
        this.missingAppIdError = true;
        this.goFollettLink = this.envService.getGoFollettLink();
      }
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (error) {
      this.missingAppIdError = false;
    }
  }

}
